var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    style: _vm.colorObject
  }, [_c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section'),
      "meta": _vm.meta
    }
  }), _vm.showPage ? _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('done_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('done_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.getModuleConfig('done_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("done_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('done_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("done_page.form_desc")) + " ")]) : _vm._e(), _vm.content ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_vm.showSuccessButton ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('done_page.button_text'),
      "button-url": _vm.getModuleConfig('done_page.button_url'),
      "type": _vm.getModuleConfig('done_page.button_action')
    }
  }) : _vm._e(), _vm.showRedirectButton ? _c('SharedButton', {
    staticClass: "s-btn-bg-secondary",
    on: {
      "click": _vm.redirectToIntended
    }
  }, [_vm._v(" " + _vm._s(_vm.redirectActionConfig.button_text) + " ")]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }